export const CommonCertificateCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sportello',
    path: '/sportello',
  },
  {
    name: 'Certificati',
    path: '/sportello/controllo-di-cassa',
  },
];
